/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const formats = {

    date: {
        text: `dd.MM.yyyy`,
    },
}
